/* ==================================================================
   NUTRADITE — theme scripts (Shopify version)
   Every feature checks whether its section is on the page before it
   runs, so nothing breaks while you are still adding sections one at
   a time. Also re-initialises when you drag sections around in the
   theme editor.
   ================================================================== */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  function initMenu(scope) {
    var burger = scope.querySelector('#burger');
    var drawer = scope.querySelector('#drawer');
    if (!burger || !drawer) return;

    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        drawer.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Product tabs ---------- */
  function initTabs(scope) {
    var lists = scope.querySelectorAll('[role="tablist"]');
    if (!lists.length) return;

    lists.forEach(function (list) {
      var tabs = Array.prototype.slice.call(list.querySelectorAll('.tab'));
      if (!tabs.length) return;

      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = tabs[(i + dir + tabs.length) % tabs.length];
          select(next);
          next.focus();
        });
      });
    });
  }

  /* ---------- Reviews slider ---------- */
  function initSlider(scope) {
    var track = scope.querySelector('#slides');
    var prev  = scope.querySelector('#prev');
    var next  = scope.querySelector('#next');
    if (!track || !prev || !next) return;

    var index = 0;

    function perView() {
      var w = window.innerWidth;
      return w >= 1120 ? 3 : w >= 820 ? 2 : 1;
    }

    function render() {
      var max = Math.max(0, track.children.length - perView());
      index = Math.min(Math.max(index, 0), max);
      track.style.transform = 'translateX(' + (-index * (100 / perView())) + '%)';
      prev.disabled = index === 0;
      next.disabled = index >= max;
    }

    prev.addEventListener('click', function () { index--; render(); });
    next.addEventListener('click', function () { index++; render(); });
    window.addEventListener('resize', render);
    render();
  }

  /* ---------- Footer year ---------- */
  function initYear(scope) {
    var el = scope.querySelector('#year');
    if (el) el.textContent = new Date().getFullYear();
  }

  /* ---------- Run everything ---------- */
  function initAll(scope) {
    var root = scope || document;
    initMenu(root);
    initTabs(root);
    initSlider(root);
    initYear(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-run when a section is added, moved or edited.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();